import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import appStore from "./app";
import account from "./account";



import setting from "./setting";
import Categories from "./categories";
import notification from "./notification/index";
import dash from "./notification/dash";
import shop from "./shop";
import shopRequest from "./shop-request";
import smsrecords from "./smsrecords";

import ad from "./ad";
import about from "./about";
import subscription from "./subscription";
import userInfo from "./user-info";
import Contacts from "./contact";
import report from "./report";
import home from "./home";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        appStore,
        auth,
        notification,
        account,
        shop,
        shopRequest,
        setting,
        Categories,
        ad,
        about,
        subscription,
        userInfo,
        Contacts,
        report,
        home,
        dash,
        smsrecords
    }
});
